import deleteSiteData from './delete-site-data';
import setSites from './set-sites';

export default {
  deleteSiteData,
  setSites,
};
